import React from "react";

export default function Footer() {
  return (
    <footer style={{
      marginTop: "40px",
      padding: "20px",
      textAlign: "center",
      borderTop: "1px solid #ddd"
    }}>
      <a href="/privacy">Privacy Policy</a> |{" "}
      <a href="/terms">Terms of Use</a> |{" "}
      <a href="/gdpr">GDPR Notice</a> |{" "}
      <a href="/cookies">Cookie Notice</a>
    </footer>
  );
}
